import { React } from 'Imports';
import { ConfirmDialog } from '$Components/Shared/ConfirmDialog';

import { useEffect, useState } from 'react';
import { IDropdownItem } from '$Components/FilterComponents/VPDropdown';
import Box from '@mui/material/Box/Box';
import SingleSelect from '$Components/FilterComponents/Filters/SingleSelect';
import { ConfigService } from '$State/ConfigFreezerService';
import { AutoScoreSettingsResponse } from '$Generated/api';

interface IAutoScoreDialogProps {
    open: boolean;
    onClose: () => void;
    isEdit: boolean;
    handleAssignEventAutoScore: (eventTypeId: number, scoreId: number) => void;
    eventTypesItems?: IDropdownItem[];
    scoresItems?: IDropdownItem[];
    selectedAutoScoreSetting?: AutoScoreSettingsResponse | null;
}

type AutoScoreDialogProps = IAutoScoreDialogProps;

const styles = require('./AutoScoreDialog.scss') as {
    pickerContent: string;
    select: string;
    headerText: string;
    editAutoScoreWarnText: string;
    scoreContainer: string;
    scoreLabel: string;
    scoreDropdown: string;
};

export const AutoScoreDialog = (props: AutoScoreDialogProps) => {
    const [eventTypeSelected, setEventTypeSelected] = useState<number | null>(null);
    const [scoreSelected, setScoreSelected] = useState<number | null>(null);
    const title = props.isEdit ? 'Edit Event Auto-Score' : 'Assign Event Auto-Score';
    const submitActionText = props.isEdit ? 'Save' : 'Assign';
    const isMovileView = ConfigService.isRunningStandAlone() ? window.innerWidth < 1858 : window.innerWidth < 1553;

    const handleOnClose = () => {
        props.onClose();
    };

    const handleEventTypeChange = (selectedItem: IDropdownItem | null) => {
        setEventTypeSelected(selectedItem?.value);
    };

    const handleScoreChange = (selectedItem: IDropdownItem | null) => {
        setScoreSelected(selectedItem?.value);
    };

    const handleOnSubmit = () => {
        props.handleAssignEventAutoScore(eventTypeSelected!, scoreSelected!);
    };

    useEffect(() => {
        if (props.selectedAutoScoreSetting && props.isEdit) {
            setEventTypeSelected(props.selectedAutoScoreSetting?.videoEventTypeId ?? 0);
            setScoreSelected(props.selectedAutoScoreSetting?.videoEventScoreId ?? 0);
        } else {
            setEventTypeSelected(null);
            setScoreSelected(null);
        }
    }, [props.selectedAutoScoreSetting, props.eventTypesItems]);

    return (
        <ConfirmDialog
            isOpen={props.open}
            title={title}
            contentMessage={
                <Box className={styles.scoreContainer}>
                    <Box width={'235px'}>
                        <SingleSelect
                            key={'displayName'}
                            label={'Event Type'}
                            items={props.eventTypesItems || []}
                            disabled={false}
                            selectionChanged={(selectedItem: IDropdownItem | null) => handleEventTypeChange(selectedItem)}
                            searchable
                            selectedValue={eventTypeSelected}
                            isMobileView={isMovileView}
                            sortItemsByValue={false}
                            required
                            hideSearchAdornments
                        />
                    </Box>
                    <Box display={'flex'} alignSelf={'flex-end'}>
                        <span className={styles.scoreLabel}>Always score as</span>
                        <div className={styles.scoreDropdown}>
                            <SingleSelect
                                key={'displayName'}
                                label={'Score'}
                                hideLabel
                                items={props.scoresItems || []}
                                disabled={false}
                                selectionChanged={(selectedItem: IDropdownItem | null) => handleScoreChange(selectedItem)}
                                searchable={false}
                                selectedValue={scoreSelected}
                                isMobileView={isMovileView}
                                sortItemsByValue={false}
                            />
                        </div>
                    </Box>
                </Box>
            }
            cancelButton={'Cancel'}
            acceptButton={submitActionText}
            isAlert={false}
            handleModalClosed={handleOnClose}
            handleSubmit={handleOnSubmit}
            disabledSubmit={
                !eventTypeSelected ||
                !scoreSelected ||
                (props.isEdit &&
                    eventTypeSelected === props.selectedAutoScoreSetting?.videoEventTypeId &&
                    scoreSelected === props.selectedAutoScoreSetting?.videoEventScoreId)
            }
            isNewSubmitButtonStyle
        ></ConfirmDialog>
    );
};
